import { helpers } from '@vuelidate/validators'

export const phoneNumberRegex = /^(\+)?\d+$/
export const phoneNumberFormat = helpers.regex(phoneNumberRegex)